<script setup lang="ts">
import type { MenuListItem } from '@/constants/menuLists';

import SmartSecondarySideBarMenuVList from '@/components/vLists/SmartSecondarySideBarMenuVList.vue';

export interface Props {
  subList?: readonly MenuListItem[];
  title?: string;
}
const props = withDefaults(defineProps<Props>(), {});
</script>

<template>
  <v-navigation-drawer
    :elevation="0"
    :width="220"
    temporary
    :class="$style.itemsSideBar"
  >
    <h4 :class="$style.title">{{ props.title }}:</h4>
    <SmartSecondarySideBarMenuVList :list="props.subList" />
  </v-navigation-drawer>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.itemsSideBar {
  background-color: colors.$color-gray-50 !important;
  border-right: 1px solid colors.$color-brand-100 !important;
}
  .title {
    color: colors.$color-gray-600;
    font-size: 0.875rem;
    font-weight: 500;
    margin: 22px 0 0 16px;
  }
</style>
